<template>
  <div
    :class="
      $vuetify.breakpoint.mdAndDown
        ? 'd-flex flex-column-reverse'
        : 'd-flex pa-3'
    "
    :style="$vuetify.breakpoint.mdAndUp ? 'gap: 12px' : ''"
  >
    <div
      :class="{
        'pa-0 col-lg-9 col-md-12 col-sm-12': $vuetify.breakpoint.mdAndUp,
      }"
    >
      <span
        v-if="isXsmall"
        class="
          headline
          font-weight-medium
          pb-4
          pl-4
        "
      >
        {{ $t("promotions") }}
      </span>

      <v-tabs
        v-model="activeTab"
        :class="$vuetify.breakpoint.smAndDown ? 'mt-4' : ''"
        color="primary"
        fixed-tabs
        :icons-and-text="isXsmall"
      >
        <!-- tab 0 -->
        <v-tab v-if="showTab0" href="#tab-0">
          <v-icon v-if="!isXsmall" left>mdi-gift-outline</v-icon>
          <div :class="tabXsmallClassButton" class="text-no-wrap">
            <!-- mobile -->
            <v-badge
              v-if="isXsmall"
              :content="badgeForYou"
              :value="badgeForYou"
              transition="fade-transition"
              color="#B3261E"
            >
              {{ $t("forYou") }}
            </v-badge>
            <!-- desktop -->
            <span v-if="!isXsmall">{{ $t("forYou") }}</span>
            <v-badge
              v-if="!isXsmall"
              inline
              :content="badgeForYou"
              :value="badgeForYou"
              color="#B3261E"
              transition="fade-transition"
            ></v-badge>
          </div>
          <v-icon v-if="isXsmall" class="mb-2">mdi-gift-outline</v-icon>
        </v-tab>

        <!-- tab 1 -->
        <v-tab
          href="#tab-1"
          :disabled="
            loadingPromotion ||
              loadings.fetchingActiveCampaigns ||
              loadings.fetchingHistoricCampaigns
          "
        >
          <v-icon v-if="!isXsmall" left>mdi-gift-open-outline</v-icon>
          <div :class="tabXsmallClassButton">
            <!-- mobile -->
            <v-badge
              v-if="isXsmall"
              :content="badgeActives"
              :value="badgeActives"
              color="#B3261E"
            >
              {{ $t("ativas") }}
            </v-badge>
            <!-- desk -->
            <span v-if="!isXsmall">{{ $t("ativas") }}</span>
            <v-badge
              v-if="badgeActives && !isXsmall"
              inline
              :content="badgeActives"
              :value="badgeActives"
              color="#B3261E"
            ></v-badge>
          </div>
          <v-icon v-if="isXsmall" class="mb-2">mdi-gift-open-outline</v-icon>
        </v-tab>

        <!-- tab 2 -->
        <v-tab
          href="#tab-2"
          :disabled="
            loadingPromotion ||
              loadings.fetchingActiveCampaigns ||
              loadings.fetchHistoricFreespinCampaigns
          "
        >
          <v-icon v-if="!isXsmall" left>mdi-clock-outline</v-icon>
          <div :class="tabXsmallClassButton">
            <!-- mobile -->
            <v-badge
              v-if="isXsmall"
              :content="badgeHistoric"
              :value="badgeHistoric"
              color="#B3261E"
              transition="fade-transition"
            >
              {{ $t("historic") }}
            </v-badge>
            <!-- desk -->
            <span v-if="!isXsmall">{{ $t("historic") }}</span>
            <v-badge
              v-if="!isXsmall"
              inline
              :content="badgeHistoric"
              :value="badgeHistoric"
              color="#B3261E"
              transition="fade-transition"
            ></v-badge>
          </div>

          <v-icon v-if="isXsmall" class="mb-2">mdi-clock-outline</v-icon>
        </v-tab>
      </v-tabs>
      <v-divider></v-divider>

      <v-card :class="{ 'px-4 pb-4': isXsmall }" class="rounded-t-0">
        <!-- toggle sports / casino / search bar -->
        <v-row
          no-gutters
          :class="
            !isXsmall
              ? `
                d-flex
                align-top
                justify-space-between
                px-4
                pt-4
                pb-4
              `
              : 'py-4'
          "
        >
          <v-col
            cols="12"
            sm="6"
            lg="6"
            :class="{ 'pr-2': !isXsmall }"
            :order="isXsmall ? 'first' : ''"
          >
            <v-btn-toggle
              v-model="sportsOrCasino"
              mandatory
              active-class="primary"
              :class="btnTogglePaddingRule"
              style="width: 100%;"
            >
              <v-btn style="flex: 1; height: 40px;">
                <v-icon left>mdi-soccer</v-icon>
                {{ $t("sports") }}
              </v-btn>
              <v-btn v-if="showFreespins" style="flex: 1; height: 40px;">
                <v-icon left>mdi-slot-machine-outline</v-icon>
                {{ $t("casino") }}
              </v-btn>
            </v-btn-toggle>
          </v-col>
          <v-col
            v-if="activeTab == 'tab-2'"
            cols="12"
            sm="6"
            lg="6"
            :class="{ 'pl-2': !isXsmall }"
          >
            <v-expand-x-transition>
              <v-text-field
                v-model="searchModel"
                :label="$t('searchByTitleAndGame')"
                append-icon="mdi-magnify"
                outlined
                dense
                hide-details
              >
              </v-text-field>
            </v-expand-x-transition>
          </v-col>
        </v-row>

        <v-tabs-items v-model="activeTab" :class="{ 'px-4 pb-4': !isXsmall }">
          <!-- Para você -->
          <v-tab-item value="tab-0">
            <div
              v-if="
                freeSpinsFetched == false &&
                  recomendedPromotionsFetched == false
              "
              :class="$vuetify.breakpoint.smAndDown ? 'mx-2' : ''"
              :max-width="$vuetify.breakpoint.smAndDown ? 400 : ''"
            >
              <v-skeleton-loader
                class="my-4"
                type="list-item-three-line"
              ></v-skeleton-loader>
              <v-row v-for="n in 2" :key="n">
                <v-col v-for="i in skeletonPerCol" :key="i">
                  <v-skeleton-loader
                    class="mx-auto"
                    :max-width="$vuetify.breakpoint.smAndDown ? 400 : ''"
                    type="card"
                  />
                </v-col>
              </v-row>
            </div>

            <v-row
              v-else-if="noFreespins == true && noPromotionsRecomended == true"
              no-gutters
            >
              <v-col>
                <v-alert
                  class="mt-4"
                  text
                  type="info"
                  color="warning"
                  border="left"
                  dense
                >
                  {{ $t("noPromotionForYou") }}
                </v-alert>
              </v-col>
            </v-row>

            <CardPromotions
              v-else-if="
                (freeSpinsFetched && !noFreespins) ||
                  (recomendedPromotionsFetched && !noPromotionsRecomended)
              "
              :freespinsFilteredBySearch="freespinsFilteredBySearch"
              :showingItemsRecommendedForYou="showingItemsRecommendedForYou"
              :recomendedPromotions="recomendedPromotions"
              :imageError="imageError"
              :sportsOrCasino="sportsOrCasino"
              @fetchData="fetchData"
            />

            <DialogGreetingsPromotionsVue
              v-if="
                casino &&
                  showFreespins &&
                  showingItemsRecommendedForYou.length > 0
              "
              :showFreespins="showFreespins"
            />
          </v-tab-item>

          <!-- Promoções Ativas -->
          <v-tab-item value="tab-1">
            <div v-if="loadingPromotion">
              <v-skeleton-loader
                class="mx-auto"
                type="card"
                :min-width="$vuetify.breakpoint.smAndDown ? '' : 400"
              />
            </div>
            <div v-else class="">
              <div>
                <div v-if="sportsOrCasino == 0">
                  <div v-if="noActivePromotion">
                    <v-alert text type="info" border="left">
                      {{ $t("noActivePromotion") }}
                    </v-alert>
                  </div>
                  <div v-else class="d-flex flex-column " style="width: 100%">
                    <PromotionList
                      :promotions="showingItemsActivePromotions"
                      :fetchPromotions="fetchPromotions"
                      :tab="activeTab"
                      :isActiveCampaigns="false"
                      :history="false"
                    />
                  </div>
                </div>

                <div v-if="sportsOrCasino == 1">
                  <v-alert
                    v-if="
                      activeFreespinsFilteredBySearch.length === 0
                        && activeSearch
                    "
                    class="mb-0"
                    text
                    type="info"
                    border="left"
                  >
                    {{ $t("newCasino.freespins.noCampaignFoundForGame") }}
                  </v-alert>
                  <div
                    v-else-if="
                      showingItemsActiveCampaigns.length === 0 &&
                        loadings.fetchingActiveCampaigns === false
                    "
                  >
                    <v-alert
                      text
                      type="info"
                      height="70"
                      border="left"
                      class="d-flex align-center mb-0"
                    >
                      {{ $t("noActivePromotion") }}
                    </v-alert>
                  </div>
                  <div v-else class="d-flex flex-column " style="width: 100%">
                    <PromotionList
                      :activeCampaigns="activeFreespinsFilteredBySearch"
                      :fetchPromotions="fetchActiveFreespinCampaigns"
                      :tab="activeTab"
                      :isActiveCampaigns="true"
                      :history="false"
                    />
                  </div>
                </div>
              </div>
            </div>
          </v-tab-item>

          <!-- Histórico -->
          <v-tab-item value="tab-2">
            <div class="mb-6">
              <div
                class="d-flex flex-column"
                style="width: 100%"
                v-if="sportsOrCasino == 0"
              >
                <div v-if="noPromotionHistory">
                  <v-alert text class="ma-0 mx-4" type="info" border="left">
                    {{ $t("noPromotionHistory") }}
                  </v-alert>
                </div>

                <div
                  v-if="
                    historicPromotionSearch &&
                      handlePromotionsHistory.length === 0
                  "
                >
                  <v-alert text outlined type="info" dense border="left">
                    {{ $t("newCasino.freespins.noCampaignFoundForGame") }}
                  </v-alert>
                </div>
                <!-- historico sports -->
                <PromotionList
                  :promotions="handlePromotionsHistory"
                  :fetchPromotions="fetchPromotions"
                  :tab="activeTab"
                  :isActiveCampaigns="false"
                  :isHistoricCampaigns="false"
                  :history="true"
                />
              </div>

              <div v-if="sportsOrCasino == 1">
                <div
                  v-if="
                    historicSearch &&
                      historicFreespinsFilteredBySearch.length === 0
                  "
                >
                  <v-alert text outlined type="info" dense border="left">
                    {{ $t("newCasino.freespins.noCampaignFoundForGame") }}
                  </v-alert>
                </div>

                <div
                  v-else-if="
                    showingItemsInactiveCampaigns.length === 0 &&
                      loadings.fetchingHistoricCampaigns === false
                  "
                >
                  <v-alert text type="info" border="left">
                    {{ $t("noActivePromotion") }}
                  </v-alert>
                </div>
                <!-- historico cassino -->
                <div v-else class="d-flex flex-column" style="width: 100%">
                  <PromotionList
                    :activeCampaigns="historicFreespinsFilteredBySearch"
                    :fetchPromotions="fetchActiveFreespinCampaigns"
                    :tab="activeTab"
                    :isActiveCampaigns="true"
                    :history="false"
                  />
                </div>
              </div>
            </div>
          </v-tab-item>
        </v-tabs-items>
      </v-card>
    </div>

    <!-- Resgate do token -->
    <div
      :class="
        $vuetify.breakpoint.xs
          ? `headline
            font-weight-medium
            pt-3
            pb-8
            px-4
            `
          : `py-0
            px-0
            mb-3
            col-lg-3
            col-md-4
            col-sm-5
            `
      "
    >
      <div class="d-flex flex-column">
        <span class="text-h5" :class="isXsmall ? 'pb-4' : 'pb-8'">
          {{ $t("redeemTokenTitle") }}
        </span>
        <!-- Dialog de resgate do token -->
        <DialogToken @refreshPromotions="fetchPromotions()" />
      </div>
    </div>
  </div>
</template>
<script>
import PromotionList from "./PromotionList";
import DialogToken from "../../../../components/promotions/dialog-token.vue";
import FreespinDetailDialog from "./FreespinDetailDialog.vue";
import DialogGreetingsPromotionsVue from "./DialogGreetingsPromotions.vue";
import CardPromotions from "./CardPromotions.vue";

export default {
  name: "DashMyPromotions",

  components: {
    PromotionList,
    DialogToken,
    FreespinDetailDialog,
    DialogGreetingsPromotionsVue,
    CardPromotions,
  },

  data: (vm) => ({
    freespinSearch: "",
    historicSearch: "",
    historicPromotionSearch: "",
    activeSearch: "",
    searchModel: "",
    interval: 0,
    loadings: {
      fetchingActiveCampaigns: true,
      fetchingHistoricCampaigns: true,
    },

    claimingFreespinId: 0,

    // Image url boilerplate
    // https://cdn.softswiss.net/i/s2/<provider>/<game.identifier>.png
    // activeTab: vm.showFreespins ? "tab-0" : "tab-1",
    activeTab: null,
    sportsOrCasino: 0,
    visibleCards: 0,
    freeSpinExpired: false,
    elementId: "",
    campaignId: "",
    freeSpinsCountInverval: [],

    // Recomendadas para você (freeSpins)
    freeSpinsFetched: false,
    noFreespins: false,
    someImageLoaded: false,
    freeSpins: [],
    showingItemsRecommendedForYou: [],
    showingItemsActivePromotions: [],
    showingItemsActiveCampaigns: [],
    showingItemsInactiveCampaigns: [],
    showingItemsHistoric: [],
    promotionsHistoricSearch: [],
    itemsLeft: [],

    // Minhas promocoes
    activePromotions: [],
    promotionHistory: [],
    promotionsFetched: false,
    loadingPromotion: false,
    noPromotions: false,
    noActivePromotion: false,
    noPromotionHistory: false,
    activeCampaigns: [],
    historicCampaigns: [],
    noActiveCampaigns: false,
    noHistoricCampaigns: false,

    // fetchRecomendedPromotions
    recomendedPromotions: [],
    possibleExtensions: ["png", "jpg", "jpeg", "webp"],
    noPromotionsRecomended: false,
    recomendedPromotionsFetched: false,
  }),

  computed: {
    showTab0() {
      return (
        this.casino &&
        this.showFreespins &&
        (this.showingItemsRecommendedForYou.length > 0 ||
          this.recomendedPromotions.length > 0)
      );
    },

    isTab0Visible() {
      if (
        this.casino &&
        this.showFreespins &&
        (this.showingItemsRecommendedForYou.length > 0 ||
          this.recomendedPromotions.length > 0)
      ) {
        return (this.activeTab = "tab-0");
      } else {
        return (this.activeTab = "tab-1");
      }
    },

    badgeForYou() {
      return (
        this.recomendedPromotions.length +
        this.showingItemsRecommendedForYou.length
      );
    },

    badgeActives() {
      return (
        this.activePromotions.length + this.showingItemsActiveCampaigns.length
      );
    },

    badgeHistoric() {
      return (
        this.promotionHistory.length + this.showingItemsInactiveCampaigns.length
      );
    },

    btnTogglePaddingRule() {
      return (
        this.isXsmall &&
        this.activeTab != "tab-0" &&
        this.activeTab != "tab-1" &&
        "mb-4"
      );
    },

    tabXsmallClassButton() {
      return this.isXsmall && "caption";
    },

    isXsmall() {
      return this.$vuetify.breakpoint.name == "xs";
    },

    handlePromotionsHistory() {
      let promotions = [];

      if (this.historicPromotionSearch) {
        this.promotionHistory.forEach((item) => {
          if (
            item.code_promo
              .toLowerCase()
              .includes(this.historicPromotionSearch.toLowerCase()) ||
            item.titulo
              .toLowerCase()
              .includes(this.historicPromotionSearch.toLowerCase())
          ) {
            promotions.push(item);
          }
        });
      } else {
        promotions.push(...this.promotionHistory);
      }
      return promotions;
    },

    activeFreespinsFilteredBySearch() {
      const campaigns = [];
      if (this.activeSearch) {
        this.showingItemsActiveCampaigns.forEach((campaign) =>
          campaign.games.forEach((game) => {
            if (
              game.game_name
                .toLowerCase()
                .includes(this.activeSearch.toLowerCase()) &&
              !campaigns.find(({ id }) => id === campaign.id)
            ) {
              campaigns.push(campaign);
            }
          })
        );
      } else {
        campaigns.push(...this.showingItemsActiveCampaigns.map((campaign) =>
          ({
            ...campaign,
            image: encodeURI(
              `https://dozr8la71aog.cloudfront.net/domains/${this.$domain()}/promotions/${
                campaign.codigo
              }.png`
            )
          })
        ));
      }

      return campaigns;
    },

    historicFreespinsFilteredBySearch() {
      const campaigns = [];

      if (this.historicSearch) {
        this.showingItemsInactiveCampaigns.forEach((campaign) =>
          campaign.games.forEach((game) => {
            if (
              game.game_name
                .toLowerCase()
                .includes(this.historicSearch.toLowerCase()) ||
              campaign.title
                .toLowerCase()
                .includes(this.historicSearch.toLowerCase())
            ) {
              campaigns.push(campaign);
            }
          })
        );
      } else {
        campaigns.push(...this.showingItemsInactiveCampaigns);
      }

      return campaigns;
    },

    freespinsFilteredBySearch() {
      if (this.freespinSearch) {
        return this.showingItemsRecommendedForYou.filter((campaign) =>
          campaign.games[0].game_name
            .toLowerCase()
            .includes(this.freespinSearch.toLowerCase())
        );
      }

      return this.showingItemsRecommendedForYou;
    },

    showFreespins() {
      return true;
    },

    casino() {
      return this.$store.state.operators.casino;
    },

    skeletonPerCol() {
      const breakpoint = this.$vuetify.breakpoint.name;

      if (breakpoint == "xs") {
        return 1;
      } else if (breakpoint == "md") {
        return 2;
      } else if (breakpoint == "lg") {
        return 2;
      } else if (breakpoint == "xl") {
        return 3;
      }
      return 1;
    },
  },

  created() {
    this.fetchData();
    // this.fetchPromotionsForYou();

    // Em caso de confirmar pagamento ao depositar, haverá um botão de redirect
    // para listagem de campanhas para o jogador reivindicar
    if (this.$route.query && this.$route.query.fromDialogDeposit == "tabCasino") {
      this.sportsOrCasino = 1;
    }
  },

  watch: {
    activeTab() {
      this.resetValues();
    },

    searchModel() {
      this.handleModel();
    },

    sportsOrCasino() {
      this.resetValues();
    },
  },

  destroyed() {
    clearInterval(this.interval);
  },

  methods: {
    // isTab0Visible () {
    //   if (
    //     this.casino &&
    //     this.showFreespins &&
    //     (
    //       this.showingItemsRecommendedForYou.length > 0 ||
    //       this.recomendedPromotions.length > 0
    //     )
    //   ) {
    //     console.log("oi")
    //     return this.activeTab = "tab-0";
    //   } else {
    //     console.log("ihuul")
    //     return this.activeTab = "tab-1";
    //   }
    // },

    resetValues() {
      this.activeSearch = "";
      this.historicSearch = "";
      this.searchModel = "";
      this.historicPromotionSearch = "";
    },

    handleModel() {
      // Ativas
      // if (this.activeTab == "tab-1") {
      //   this.activeSearch = this.searchModel;
      // }
      // histórico
      if (this.activeTab == "tab-2") {
        if (this.sportsOrCasino == 0) {
          this.historicPromotionSearch = this.searchModel;
        }
        if (this.sportsOrCasino == 1) {
          this.historicSearch = this.searchModel;
        }
      }
    },

    setActiveCampaignsExpirationDate() {
      this.showingItemsActiveCampaigns = this.showingItemsActiveCampaigns.map(
        (item) => {
          let countDownDate = new Date(item.expiration_date)
            .getTime()
            .toString();

          // Get today's date and time
          let dateNow = new Date().getTime();

          // Find distance between now and the count down date
          let distance = countDownDate - dateNow;

          // Time calculations for days, hours, minutes and seconds
          let days = Math.floor(distance / (1000 * 60 * 60 * 24));

          let hours = Math.floor(
            (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
          );

          let minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
          // let seconds = Math.floor((distance % (1000 * 60)) / 1000);

          const expiresIn = {};

          if (distance < 0) {
            expiresIn.text = this.$t("expired");
            expiresIn.class = "orange--text";
          } else if (days > 1) {
            expiresIn.text = `${this.$t("expiresIn")} ${new Date(
              item.expiration_date
            ).toLocaleDateString()}`;
            expiresIn.class = "red--text";
          } else {
            if (hours < 10) {
              hours = "0" + hours;
            }

            if (minutes < 10) {
              minutes = "0" + minutes;
            }

            expiresIn.text = this.$t("newCasino.freespins.expiresIn", {
              hour: hours,
              minute: minutes,
            });
            expiresIn.class = "red--text";
          }

          return { ...item, expiresIn };
        }
      );
    },

    async fetchData() {
      clearInterval(this.interval);
      await this.fetchPromotionsForYou();
      await this.fetchFreeSpinsForYou();
      this.fetchPromotions();
      this.fetchActiveFreespinCampaigns();
      this.fetchHistoricFreespinCampaigns();
    },

    async fetchPromotionsForYou() {
      await this.$axios
        .get("/player/bonus/promotion/listAvaliable")
        .then((res) => {
          this.noPromotionsRecomended = false;

          const data = res.data.dados.filter(
            (promotion) => promotion.hide === "0" && promotion.product_type === "sportbook"
          );

          this.recomendedPromotions = data.map((promotion) => ({
            ...promotion,
            image: encodeURI(
              `https://dozr8la71aog.cloudfront.net/domains/${this.$domain()}/promotions/${
                promotion.code_promo
              }.${this.possibleExtensions[0]}`
            ),
          }));

          if (this.recomendedPromotions.length === 0) {
            this.noPromotionsRecomended = true;
          }
        })
        .catch(() => {
          this.noPromotionsRecomended = true;
        })
        .finally(() => {
          this.recomendedPromotionsFetched = true;
        });
    },

    imageError({ src, index, code, isCardPromotions = false }) {
      let currExtension = src.split(".")[src.split(".").length - 1];
      let currExtensionIndex = this.possibleExtensions.indexOf(currExtension);
      let nextExtensionIndex = currExtensionIndex + 1;

      if (nextExtensionIndex == this.possibleExtensions.length) {
        return;
      }

      let nextExtension = this.possibleExtensions[nextExtensionIndex];

      if (isCardPromotions) {
        this.freespinsFilteredBySearch[index].image = encodeURI(
          `https://dozr8la71aog.cloudfront.net/domains/${this.$domain()}/promotions/${code}.${nextExtension}`
        );
      } else {
        this.recomendedPromotions[index].image = encodeURI(
          `https://dozr8la71aog.cloudfront.net/domains/${this.$domain()}/promotions/${code}.${nextExtension}`
        );
      }
    },

    async fetchFreeSpinsForYou() {
      this.freeSpinsFetched = false;

      await this.$axios
        .get("player/online/casino/freespins/listClaim")
        .then((response) => {
          this.freeSpins = response.data.dados.map((campaign) => {
            return {
              ...campaign,
              game_identifier: campaign.codigo ? campaign.games :
              campaign.games[0].game_identifier,
              image: encodeURI(`https://dozr8la71aog.cloudfront.net/domains/${
                this.$domain()
              }/promotions/${campaign.codigo}.png`)
            }});

          // movido para dentro do componente CardPromotions
          // clearInterval(this.interval);
          // this.countForYouCasino = this.showingItemsRecommendedForYou.length;
          // this.interval = setInterval(() => {
            //   this.counterDateExpiration();
            // }, 1000);
            this.showingItemsRecommendedForYou = this.freeSpins;
        })
        .catch(() => {
          this.freeSpins = [];
          this.showingItemsRecommendedForYou = this.freeSpins;
        })
        .finally(() => {
          // aqui
          // this.activeTab =
          //   this.showingItemsRecommendedForYou.length > 0 ? "tab-0" : "tab-1";
          this.freeSpinsFetched = true;
          this.isTab0Visible;
        });
    },

    fetchPromotions() {
      this.loadingPromotion = true;

      this.$axios
        .post("/player/bonus/promotion/listActives")
        .then((res) => {
          if (res.data.dados.active_promotion) {
            const promotion = res.data.dados.active_promotion;
            promotion.bonusGained = promotion.valor_bonus;
            promotion.rolloverProgress = this.getRolloverProgress(promotion);
            promotion.progressTooltip = this.getProgressTooltip(promotion);
            promotion.expand = false;

            this.activePromotions = [promotion];
            this.showingItemsActivePromotions = this.activePromotions;
            this.noActivePromotion = false;
          } else {
            this.noActivePromotion = true;
          }

          if (res.data.dados.promotion_history.length > 0) {
            const promotionHistory = res.data.dados.promotion_history.map(
              (promotion) => {
                promotion.bonusGained = promotion.valor_bonus;
                promotion.rolloverProgress = this.getRolloverProgress(
                  promotion
                );
                promotion.progressTooltip = this.getProgressTooltip(promotion);
                promotion.expand = false;
                return promotion;
              }
            );

            this.promotionHistory = promotionHistory;
            this.showingItemsHistoric = promotionHistory;

            this.noPromotionHistory = false;
          } else {
            this.noPromotionHistory = true;
          }
        })
        .catch(() => {
          this.noActivePromotion = true;
          this.noPromotionHistory = true;
        })
        .finally(() => {
          this.loadingPromotion = false;
          // aqui
          // this.activeTab =
          //   this.showingItemsRecommendedForYou.length > 0 ? "tab-0" : "tab-1";
          this.isTab0Visible;
        });
    },

    fetchActiveFreespinCampaigns() {
      this.loadings.fetchingActiveCampaigns = true;

      const body = this.$formdata({ status: 1 });
      this.$axios
        .post("/player/online/casino/freespins/list", body)
        .then((res) => {
          this.showingItemsActiveCampaigns = res.data.dados;
          this.setActiveCampaignsExpirationDate();
        })
        .catch(() => {
          this.showingItemsActiveCampaigns = [];
        })
        .finally(() => {
          this.loadings.fetchingActiveCampaigns = false;
          // aqui
          // this.activeTab =
          //   this.showingItemsRecommendedForYou.length > 0 ? "tab-0" : "tab-1";
          this.isTab0Visible;
        });
    },

    fetchHistoricFreespinCampaigns() {
      this.loadings.fetchingHistoricCampaigns = true;

      const body = this.$formdata({ status: 0 });
      this.$axios
        .post("/player/online/casino/freespins/list", body)
        .then((res) => {
          this.showingItemsInactiveCampaigns = res.data.dados;
        })
        .catch(() => {
          this.noHistoricCampaigns = true;
        })
        .finally(() => {
          this.loadings.fetchingHistoricCampaigns = false;
          // aqui
          // this.activeTab =
          //   this.showingItemsRecommendedForYou.length > 0 ? "tab-0" : "tab-1";
          this.isTab0Visible;
        });
    },

    getRolloverProgress(promotion) {
      const currentRollover = promotion.rollover_atual || 0;
      const totalRollover = promotion.rollover_total;
      const ratio = currentRollover / totalRollover;
      const percentage = ratio * 100;

      if (percentage >= 100) {
        return 100;
      }

      return Math.trunc(percentage * 100) / 100;
    },

    getProgressTooltip(promotion) {
      const currentRollover = promotion.rollover_atual || 0;
      const totalRollover = promotion.rollover_total;
      const betValueDiff = totalRollover - currentRollover;
      const betValueLeft = betValueDiff.toFixed(2);
      return this.$t("progressTooltip", {
        betValueLeft,
      });
    },

    // movido para dentro do componente CardPromotions
    // counterDateExpiration() {
    //   this.showingItemsRecommendedForYou = this.showingItemsRecommendedForYou.map(
    //     (item) => {
    //       let countDownDate = new Date(item.final_date_to_claim).getTime().toString();

    //       // Get today's date and time
    //       let dateNow = new Date().getTime();

    //       // Find distance between now and the count down date
    //       let distance = countDownDate - dateNow;

    //       // Time calculations for days, hours, minutes and seconds
    //       let days = Math.floor(distance / (1000 * 60 * 60 * 24));

    //       let hours = Math.floor(
    //         (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
    //       );

    //       let minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    //       // let seconds = Math.floor((distance % (1000 * 60)) / 1000);

    //       const expiresIn = {};

    //       if (distance < 0) {
    //         expiresIn.text = this.$t("expired");
    //         expiresIn.class = "orange--text";
    //       } else if (days >= 1) {
    //         expiresIn.text = `${this.$t("expiresIn")} ${new Date(
    //           item.final_date_to_claim
    //         ).toLocaleDateString()}`;
    //         expiresIn.class = "red--text";
    //       } else {
    //         if (hours < 10) {
    //           hours = "0" + hours;
    //         }

    //         if (minutes < 10) {
    //           minutes = "0" + minutes;
    //         }

    //         expiresIn.text = this.$t("newCasino.freespins.expiresIn", {
    //           hour: hours,
    //           minute: minutes,
    //         });
    //         expiresIn.class = "red--text";
    //       }

    //       return { ...item, expiresIn };
    //     }
    //   );
    // },

    src(game_identifier) {
      return game_identifier
        ? encodeURI(
            `https://cdn.softswiss.net/i/s2/${game_identifier.split(":")[0]}/${
              game_identifier.split(":")[1]
            }.png`
          )
        : "";
    },
  },
};
</script>
